import { FC, useEffect, useMemo, useState } from "react";

import { Footer } from "./Navigation";
import { useAppSelector } from "../store";
import { pageError } from "../routes/error";
import { OnProgress, BUTTONS_TITLE } from "../auth";
import { LoaderIcon } from "../ui/icons";

const displayComponent = {
  loading: {
    title: "Loading",
    component: <LoaderIcon className="animate-spin" />,
  },
  onboarding: {
    title: BUTTONS_TITLE.startNew,
    component: <OnProgress />,
  },
  error: { title: "Error", component: pageError("503") },
};

const TIME_TO_SHOW_SLOW_REQUEST_MESSAGE = 2000;

export const TransitionLayout: FC = () => {
  const [showSlowRequestMessage, setShowSlowRequestMessage] = useState(false);

  const pages = useAppSelector((state) => state.pages);
  const { companies, error } = useAppSelector((state) => state.companies);
  const isUserFromOnboarding = useAppSelector((state) => state.user.onboarding);

  const pagesLoading = pages.status === "loading";
  const isOnboarding = isUserFromOnboarding === true && companies.length === 0;

  useEffect(() => {
    if (!pagesLoading) return;
    const timerId = setTimeout(() => {
      pagesLoading && setShowSlowRequestMessage(true);
    }, TIME_TO_SHOW_SLOW_REQUEST_MESSAGE);

    return () => {
      clearTimeout(timerId);
    };
  }, [pagesLoading]);

  const display = useMemo(
    () =>
      isOnboarding
        ? displayComponent.onboarding
        : error === false
          ? displayComponent.loading
          : displayComponent.error,
    [isOnboarding, error],
  );

  return (
    <div className="relative h-screen">
      <div className="flex h-screen flex-col justify-center bg-stone-100 dark:bg-stone-900 sm:px-6 lg:px-8">
        <title>{display.title}</title>
        <div className="flex grow flex-col justify-center sm:mx-auto sm:w-full sm:max-w-md">
          <div className="mx-4 my-auto flex flex-col items-center">
            {display.component}
            {pagesLoading && showSlowRequestMessage && (
              <p className="mt-3 text-center text-sm dark:text-white">
                It seems that the process is taking more time than usual.
                <br />
                Please refresh the page or attempt it again later.
              </p>
            )}
          </div>
        </div>
      </div>
      <Footer className="fixed bottom-0" />
    </div>
  );
};
